import { Component, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faAngleDown,
	faAngleUp,
	faClock,
	faCircleXmark,
	faPlusCircle,
	faFileExcel,
	faList,
	faCalendarWeek,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import BadgePerson from '@/components/BadgePerson/index.vue'
import WrapperWeek from '@/components/WrapperWeek/index.vue'
import ModalDeadline from '@/components/edit/ModalDeadline/index.vue'
import Control from '@/helpers/control'
import ViewYearMonth from '@/components/ViewYearMonth/index.vue'

import { bus } from '@/main'
import fetch from '@/helpers/fetch'

library.add(
	faAngleDown,
	faAngleUp,
	faClock,
	faCircleXmark,
	faPlusCircle,
	faFileExcel,
	faCalendarWeek,
	faList,
)

const hourInMs = 60 * 60 * 1000
const dayInMs = 24 * hourInMs
const weekInMs = 7 * dayInMs

const weekDayNames = [
	'Domingo',
	'Segunda-feira',
	'Terça-feira',
	'Quarta-feira',
	'Quinta-feira',
	'Sexta-feira',
	'Sábado',
]

const midDayUtcString = 'T12:00:00.000Z'

const emptyWeek = [
	{ notBusinessDay: true },
	{},
	{},
	{},
	{},
	{},
	{ notBusinessDay: true },
]

@Component({
	components: {
		Loader,
		BadgePerson,
		WrapperWeek,
		ModalDeadline,
		ViewYearMonth,
	},
})
export default class Deadlines extends Vue {
	visibleWeekIndex = 0
	control = new Control()

	now: Date | null = null
	creating = false

	weekListMatrixNegative: any[] = []
	weekListMatrixPositive: any[] = []

	resetWeeks() {
		this.weekListMatrixNegative = [
			{
				dayList: emptyWeek,
			},
		]

		this.weekListMatrixPositive = [
			{
				dayList: emptyWeek,
			},
			{
				dayList: emptyWeek,
			},
		]
	}

	// get deadlinesInternalByDay() {
	// 	return this.$store.state.deadlines.deadlinesInternalByDay
	// }

	// get deadlinesFatalByDay() {
	// 	return this.$store.state.deadlines.deadlinesFatalByDay
	// }

	// get deadlinesRealFatalByDay() {
	// 	return this.$store.state.deadlines.deadlinesRealFatalByDay
	// }

	get deadlinesByDay() {
		return this.$store.state.deadlines.deadlinesByDay
	}

	get responsibleById() {
		return this.$store.state.deadlines.responsibleById
	}

	get responsibleCostsById() {
		return this.$store.state.deadlines.responsibleCostsById
	}

	get responsibleByIdArray() {
		return this.$store.state.deadlines.responsibleByIdArray
	}

	get responsibleCostsByIdArray() {
		return this.$store.state.deadlines.responsibleCostsByIdArray
	}

	get responsibleCostsId() {
		return this.$store.state.deadlines.responsibleCostsId
	}

	get responsibleId() {
		return this.$store.state.deadlines.responsibleId
	}

	get totalNumber() {
		return this.$store.state.deadlines.totalNumber
	}

	get totalProvidencesNumber() {
		return this.$store.state.deadlines.totalProvidencesNumber
	}

	get totalNumberInRange() {
		return this.$store.state.deadlines.totalNumberInRange
	}

	get totalProvidencesInRange() {
		return this.$store.state.deadlines.totalProvidencesInRange
	}

	get weekNumber() {
		const result = this.convertIndex(this.visibleWeekIndex)
		const weekData = result.matrix[result.index]
		if (weekData) {
			return weekData.totalWeek
		}

		return 0
	}

	get weekProvidencesNumber() {
		const result = this.convertIndex(this.visibleWeekIndex)
		const weekData = result.matrix[result.index]
		if (weekData) {
			return weekData.totalProvidencesWeek
		}

		return 0
	}

	async mounted() {
		window.addEventListener('resize', this.getHeight)

		await this.start(true)
		this.getHeight()
	}

	unmounted() {
		window.removeEventListener('resize', this.getHeight)
	}

	height: null | number = null
	getHeight() {
		this.$nextTick(() => {
			const wrapperWeekVisible: any = this.$refs.wrapperWeekVisible
			if (wrapperWeekVisible) {
				const height: any = wrapperWeekVisible.offsetHeight
				this.height = height
			}
		})
	}

	isListening = false
	async start(request) {
		const now = new Date()
		now.setHours(12)
		now.setMinutes(0)
		now.setSeconds(0)
		this.now = now

		if (!this.isListening) {
			bus.$on('open-modal-deadline', (id) => {
				this.$store.dispatch('selectDeadlineId', id)
				this.$bvModal.show('modal-deadline')
			})
			this.isListening = true
		}

		if (!this.selectedDeadlineType) {
			this.selectDeadlineType('internal')
		}

		if (this.visualization === 'week') {
			this.resetWeeks()
		}

		if (request) {
			await this.$store.dispatch('fetchDeadlines', {
				selectedDeadlineType: this.selectedDeadlineType,
				status: this.status,
				costsStatus: this.costsStatus,
				pendency: this.pendency,
			})
		} else {
			this.$store.dispatch('triggerDeadlines')
		}

		if (this.visualization === 'week') {
			this.loadWeek(-1)
			this.loadWeek(0)
			this.loadWeek(1)
		}
	}

	async loadWeek(visibleWeekIndex, callback?) {
		if (this.now) {
			const baseDate = new Date(
				this.now.getTime() + weekInMs * visibleWeekIndex,
			)

			const sunday = removeTime(getPreviousSunday(baseDate))
			const result = this.convertIndex(visibleWeekIndex)

			const weekData = result.matrix[result.index]
			if (!weekData) {
				Vue.set(result.matrix, result.index, {
					dayList: emptyWeek,
				})
			} else if (weekData.dayList && !weekData.dayList[0].date) {
				let currDate = new Date(sunday + midDayUtcString)
				let totalWeek = 0
				let totalProvidencesWeek = 0
				const selectedDeadlineType =
					this.selectedDeadlineType || 'internal'

				const newWeek = weekData.dayList.map((day) => {
					const today = removeTime(currDate) === removeTime(this.now)
					const currDateNoTime = removeTime(currDate)
					const dayObj = getDayObject(
						currDate,
						{ today },
						this.deadlinesByDay[selectedDeadlineType],
					)
					currDate = new Date(currDate.getTime() + dayInMs)
					if (dayObj.deadlines) {
						totalWeek += dayObj.deadlines.length
						totalProvidencesWeek += dayObj.numberOfProvidences
					}
					return { ...day, ...dayObj, currDateNoTime }
				})
				const newObj = {
					...weekData,
					totalWeek,
					totalProvidencesWeek,
					dayList: newWeek,
				}
				Vue.set(result.matrix, result.index, newObj)

				if (callback && typeof callback === 'function') {
					callback()
				}
			}
		}
	}

	async moveDown() {
		this.visibleWeekIndex += 1

		this.loadWeek(this.visibleWeekIndex)
		this.loadWeek(this.visibleWeekIndex + 1)
	}

	async moveUp() {
		this.visibleWeekIndex -= 1

		this.loadWeek(this.visibleWeekIndex)
		this.loadWeek(this.visibleWeekIndex - 1)
	}

	convertIndex(index) {
		if (index < 0) {
			return {
				index: Math.abs(index + 1),
				matrix: this.weekListMatrixNegative,
			}
		}

		return {
			index,
			matrix: this.weekListMatrixPositive,
		}
	}

	get selectedDeadlineType() {
		return this.$store.state.deadlines.selectedDeadlineType
	}

	selectDeadlineType(name) {
		const keys = Object.keys(this.deadlinesByDay)

		const result = keys.find((key) => {
			return key === name
		})

		this.$store.dispatch('selectDeadlineType', result)
	}

	selectDeadlineTypeAndStart(name) {
		this.selectDeadlineType(name)
		this.start(false)
	}

	async newDeadline() {
		this.creating = true
		const result = await this.$store.dispatch('createDeadline')
		this.creating = false

		await this.start(true)

		this.$store.dispatch('selectDeadlineId', result.id)
		this.$bvModal.show('modal-deadline')
	}

	filter(id, type) {
		this.selectedCnj = null
		type === 'costs'
			? this.$store.dispatch('filterDeadlinesByCosts', id)
			: this.$store.dispatch('filterDeadlines', id)
		this.start(false)
	}

	downloading = false
	csvHref = ''
	downloadProp = 'prazos.csv'
	async downloadCsv() {
		this.downloading = true

		const res = await fetch.get('/api/deadlines/csv')
		const csvContent = res.data

		const encodedUri = encodeURI(csvContent)

		this.csvHref = 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri

		const time = new Date().getTime() - 3 * 60 * 60 * 1000

		this.downloadProp =
			'prazos-' + new Date(time).toISOString().substring(0, 16) + '.csv'

		await Vue.nextTick()
		const link: any = this.$refs.csvLink

		if (link && link.click) {
			link.click()
			this.downloading = false
		}
	}

	getSelectedText(getSelectedText) {
		switch (getSelectedText) {
			case 'internal':
				return 'Prazo interno'
			case 'fatal':
				return 'Prazo fatal'
			case 'realFatal':
				return 'Prazo fatal real'
		}

		return getSelectedText
	}

	onCnjInput($event) {
		const cnj = $event.target.value
		const debouncedChange = this.control.debounce(this.filterByCnj, 500)
		debouncedChange(cnj)
	}

	selectedCnj = null
	filterByCnj(cnj) {
		this.$store.dispatch('filterDeadlinesByCnj', cnj)
		this.start(false)
	}

	visualization = 'list'
	async changeVisualization(value) {
		this.visualization = value
		if (value === 'week') {
			this.height = null
			await this.start(false)
			await Vue.nextTick()
			this.getHeight()
		}
	}

	organizeByYearAndMonth(object) {
		if (object && Object.keys(object).length) {
			const deadlinesByYearAndMonth = {}
			const dates = Object.keys(object)

			for (const date of dates) {
				const deadlineList = object[date]

				for (const deadline of deadlineList) {
					const splitted = date.split('-')
					const year = splitted[0]
					const month = parseInt(splitted[1], 10).toString()
					const day = parseInt(splitted[2], 10).toString()

					deadlinesByYearAndMonth[year] =
						deadlinesByYearAndMonth[year] || {}
					deadlinesByYearAndMonth[year][month] =
						deadlinesByYearAndMonth[year][month] || {}
					deadlinesByYearAndMonth[year][month][day] =
						deadlinesByYearAndMonth[year][month][day] || []

					deadlinesByYearAndMonth[year][month][day].push(deadline)
				}
			}

			return deadlinesByYearAndMonth
		}

		return null
	}

	// status = 'open'
	// onShowClosedInput($event) {
	// 	this.selectedCnj = null
	// 	this.$store.dispatch('filterDeadlinesByCnj', null)
	// 	this.$store.dispatch('filterDeadlines', null)

	// 	const target = $event.target
	// 	const value = target.checked
	// 	this.status = value ? 'closed' : 'open'
	// 	this.visibleWeekIndex = 0
	// 	this.start(true)
	// }

	// costsStatus = false
	// onShowCostsStatusInput($event) {
	// 	this.selectedCnj = null
	// 	this.$store.dispatch('filterDeadlinesByCnj', null)
	// 	this.$store.dispatch('filterDeadlines', null)

	// 	const target = $event.target
	// 	const value = target.checked
	// 	this.costsStatus = value
	// 	this.visibleWeekIndex = 0
	// 	this.start(true)
	// }

	status = 'open'
	costsStatus = false
	pendency = false

	onToggleFilter($event, filterType) {
		this.selectedCnj = null
		this.$store.dispatch('filterDeadlinesByCnj', null)
		this.$store.dispatch('filterDeadlines', null)

		const value = $event.target.checked

		if (filterType === 'status') {
			this.status = value ? 'closed' : 'open'
		} else if (filterType === 'costsStatus') {
			this.costsStatus = value
		} else if (filterType === 'pendency') {
			this.pendency = value
		}

		this.visibleWeekIndex = 0
		this.start(true)
	}

	onDelete() {
		this.start(true)
	}
}

function isBusiness(weekDayName) {
	let result = true

	if (weekDayName === 'Domingo' || weekDayName === 'Sábado') {
		result = false
	}

	return result
}

function getDayObject(date, mergeObj, deadlinesPerSelectedDay) {
	const monthDay = date.getDate()
	const monthNumberString = getMonthNumber(date)
	const weekDayName = weekDayNames[date.getDay()]
	const weekDayNumber = weekDayNames.indexOf(weekDayName)

	const nextDay = new Date(date.getTime() + dayInMs)
	const nextDayMonthNumberString = getMonthNumber(nextDay)
	const lastDayOfMonth = monthNumberString !== nextDayMonthNumberString

	const prevDay = new Date(date.getTime() - dayInMs)
	const prevDayMonthNumberString = getMonthNumber(prevDay)
	const firstDayOfMonth = monthNumberString !== prevDayMonthNumberString

	const currDateNoTime = removeTime(date)
	const deadlines = deadlinesPerSelectedDay[currDateNoTime]

	let numberOfProvidences = 0
	if (deadlines && deadlines.length) {
		deadlines.forEach((deadline) => {
			if (deadline.providences && deadline.providences.length) {
				numberOfProvidences += deadline.providences.length
			}
		})
	}

	const obj = {
		...mergeObj,
		date: date.toISOString(),
		businessDay: isBusiness(weekDayName),
		notBusinessDay: !isBusiness(weekDayName),
		monthDay,
		monthNumberString,
		weekDayNumber,
		visibleDate: formatDate(date),
		lastDayOfMonth,
		firstDayOfMonth,
		monthName: getMonthName(date),
		deadlines,
		numberOfProvidences,
	}

	return obj
}

function getMonthNumber(date) {
	const options: any = {
		month: '2-digit',
	}

	return date.toLocaleDateString('pt-BR', options)
}

function getMonthName(date) {
	const options: any = {
		month: 'long',
	}

	return date.toLocaleDateString('pt-BR', options)
}

function formatDate(date) {
	let weekDayName = weekDayNames[date.getDay()]
	const options: any = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}

	if (weekDayName === 'Domingo') {
		weekDayName = 'Dom'
		delete options.year
	}

	if (weekDayName === 'Sábado') {
		weekDayName = 'Sab'
		delete options.year
	}

	return weekDayName + ', ' + date.toLocaleDateString('pt-BR', options)
}

function getPreviousSunday(d) {
	let currDate = d

	let currDayOfWeekName = getDayOfWeekName(currDate)

	while (currDayOfWeekName !== 'Domingo') {
		currDate = new Date(currDate.getTime() - dayInMs)
		currDayOfWeekName = getDayOfWeekName(currDate)
	}

	return currDate
}

function getNextSaturday(d) {
	let currDate = d
	let currDayOfWeekName = getDayOfWeekName(currDate)

	while (currDayOfWeekName !== 'Sábado') {
		currDate = new Date(currDate.getTime() + dayInMs)
		currDayOfWeekName = getDayOfWeekName(currDate)
	}

	return currDate
}

function getDayOfWeekName(d) {
	const dayOfWeekNumber = d.getDay()
	return weekDayNames[dayOfWeekNumber]
}

function removeTime(date) {
	return date?.toISOString()?.split('T')?.[0]
}
